import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/selfLoder";
import dayjs from "dayjs";
import { useState } from "react";
import Swal from "sweetalert2";
import { employee_id } from "../../environment";

const ResginationApplication = () => {
    // const [Resignationstatus, setResignationstatus] = useState("PENDING");
    const [refreshKey, setRefreshKey] = useState(0);

    const { data: resignationData, loading: resignationProfileLoad } = useApi('/api/manager/team-resignationlist', {
        method: "GET",
        autoCall: true,
        dependencies: [refreshKey]   //dependencies: [leavestatus, refreshKey],
    })


    // console.log("Resignation Data :", resignationData.data[0].status)

    const {
        data: approve_data,
        loading: approverLoading,

        callApi: callApproveApi,
    } = useApi("/api/manager/offboarding-request-approval", {
        method: "POST",
        autoCall: false,
    })

    const {
        data: reject_data,
        loading: rejectLoading,

        callApi: callRejectApi,
    } = useApi("/api/manager/offboarding-request-rejection", {
        method: "POST",
        autoCall: false,
    })

    const columns = [
        {
            title: "Employee Code",
            dataIndex: "employee_id",
            key: "employee_id",
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
            render: (text: string, record: any) => (
                <Link to={`/offboarding/manager-view/${record.id}`}
                    style={{
                        textDecoration: "underline",
                        color: "#0d6efd",          // Bootstrap primary
                        fontWeight: 500,
                        backgroundColor: "#e7f1ff",
                        padding: "2px 4px",
                        borderRadius: "4px"
                    }}>
                    {text}
                </Link>
            ),
        },
        {
            title: "Date of Joining",
            dataIndex: "join_date",
            key: "join_date",
            render: (text: string, record: any) => (
                dayjs(record.join_date).format("DD MMMM YYYY")
            )
        },
        {
            title: "Date of Resignation",
            dataIndex: "resignation_date",
            key: "resignation_date",
            render: (text: string, record: any) => (
                dayjs(record.resignation_date).format("DD MMMM YYYY")
            )
        },
        // {
        //     title: "Zone",
        //     dataIndex: "zone",
        //     key: "zone",
        // },
        {
            title: "Branch Name",
            dataIndex: "branch_name",
            key: "branch_name",
        },
        {
            title: "Department Name",
            dataIndex: "department",
            key: "department",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text: string, record: any) => (
                <span
                    className={`badge ${text.toLowerCase().includes("approved")
                        ? "bg-success"
                        : text.toLowerCase().includes("rejected")
                            ? "bg-danger"
                            : "bg-warning"
                        }`}
                >
                    {
                        text === "Approved" ? "Accepted"
                            : text === "Pending" ? "Pending"
                                : text === "Rejected" ? "Retained"
                                    : "Withdrawn" // fallback
                    }
                </span>
            ),
        },
        {
            title: "Application Form",
            dataIndex: "",
            key: "",
            render: (text: string, record: any) => (
                <div
                // className="action-icon d-inline-flex"
                >
                    <Link to={`/offboarding/manager-view/${record.id}`}
                        style={{
                            textDecoration: "underline",
                            color: "#0d6efd",          // Bootstrap primary
                            fontWeight: 500,
                            backgroundColor: "#e7f1ff",
                            padding: "2px 4px",
                            borderRadius: "4px"
                        }}
                    // className="text-info text-center"
                    >
                        <span>View Form</span>
                        {/* // <i className="ti ti-eye" /> */}
                    </Link>
                </div>
            ),
        },
        // {
        //     title: "Action",
        //     dataIndex: "actions",
        //     render: (_: any, record: any) => {
        //         const isPending = record.status === "Pending";
        //         const isFinal = record.status === "Approved" || record.status === "Rejected";

        //         return (
        //             <div className="action-icon d-inline-flex">
        //                 {/* Read/View Icon */}
        //                 <>
        //                     {/* Approve Icon */}
        //                     <span
        //                         className={isPending ? "text-success  me-2" : "text-muted  me-2"}
        //                         title={
        //                             isPending
        //                                 ? "Approve"
        //                                 : "Action allowed only when status is Pending"
        //                         }
        //                         style={{
        //                             cursor: isPending ? "pointer" : "not-allowed",
        //                         }}
        //                         onClick={() => {
        //                             if (isPending) {
        //                                 approveOffboardingRequest(record.employee_id);
        //                             }
        //                         }}
        //                     >
        //                         <i className="ti ti-circle-check" />
        //                     </span>
        //                     <span
        //                         className={isPending ? "text-danger" : "text-muted"}
        //                         title={
        //                             isPending
        //                                 ? "Reject"
        //                                 : "Action allowed only when status is Pending"
        //                         }
        //                         style={{
        //                             cursor: isPending ? "pointer" : "not-allowed",
        //                         }}
        //                         onClick={() => {
        //                             if (isPending) {
        //                                 rejectOffboardingRequest(record.employee_id);
        //                             }
        //                         }}
        //                     >
        //                         <i className="ti ti-circle-x" />
        //                     </span>
        //                 </>
        //             </div>
        //         );
        //     },
        // },
        {
            title: "Clearance",
            key: "clearance",
            render: (_: any, record: any) => {
                const isApproved = record.status === "Approved";

                return (
                    <div className="action-icon d-inline-flex">
                        {isApproved ? (
                            <Link
                                to={`/resignation/clearance/${record.employee_id}`}
                                className="text-info"
                                title="View Clearance"
                            >
                                <i className="ti ti-eye" />
                            </Link>
                        ) : (
                            <Link
                                to={"#"}
                                className="text-muted"
                                title="Clearance available only after approval"
                                style={{ cursor: "not-allowed" }}
                            >
                                <i className="ti ti-eye" />
                            </Link>
                        )}
                    </div>
                );
            },
        }

    ];
    // const columns = [
    //     ...baseColumns,
    //     ...(resignationData?.data[0]?.status == "Approved"
    //         ? [

    //         ]
    //         : []),
    // ];


    const approveOffboardingRequest = async (employeeId: any) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this offboarding request?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
        });

        // Proceed only if user confirms
        if (result.isConfirmed) {
            const payload = {
                employee_id: employeeId,
                status: "Approved",  // The status will be set as "Approved"
            };

            try {
                const response = await callApproveApi(payload);

                // Check for success status
                if (response.statusCode === 200 || response.statusCode === 201) {
                    Swal.fire({
                        icon: response.success ? "success" : "error",
                        title: response.success ? "Offboarding Request Approved" : "Approval Failed",
                        text: response?.message || "The offboarding request has been approved successfully.",
                        showConfirmButton: true,
                    });

                    // Refresh key to trigger UI update
                    setRefreshKey(prev => prev + 1);
                }
            } catch (err: any) {
                console.error("Failed to approve offboarding request:", err);
                Swal.fire({
                    icon: "error",
                    title: "Approval Failed",
                    text: err?.response?.data?.message || "Something went wrong while approving the offboarding request.",
                });
            }
        }
    };


    const rejectOffboardingRequest = async (employeeId: any) => {
        const result = await Swal.fire({
            title: "Reject Offboarding Request",
            text: "Are you sure you want to reject this offboarding request?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Reject",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            const payload = {
                employee_id: employeeId,
                // No rejection reason included in the payload anymore
            };

            try {
                const response = await callRejectApi(payload);

                Swal.fire({
                    icon: response.success === true ? "success" : "error",
                    title: response.success === true ? "Offboarding Request Rejected" : "Rejection Failed",
                    text: response?.message || "The offboarding request has been rejected.",
                    showConfirmButton: true,
                });

                setRefreshKey(prev => prev + 1);
            } catch (err: any) {
                console.error("Failed to reject offboarding request:", err);
                Swal.fire({
                    icon: "error",
                    title: "Rejection Failed",
                    text: err?.response?.data?.message || "Something went wrong while rejecting the offboarding request.",
                    showConfirmButton: true,
                });
            }
        }
    };


    return (
        <>
            <Loader loading={resignationProfileLoad} />
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Heading */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Offboarding Applications</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Offboarding</li>
                                    <li className="breadcrumb-item active">
                                        Offboarding Applications
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    {/* Card */}
                    <div className="card">

                        <div className="card-body px-0">
                            <Table
                                dataSource={resignationData?.data ? resignationData.data : []}
                                columns={columns}
                                Selection={false}
                                showSearchInput={true}
                            />


                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
                    <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default ResginationApplication;


// import { Link } from "react-router-dom";
// import { useState } from "react";
// import dayjs from "dayjs";
// import Swal from "sweetalert2";

// import { all_routes } from "../router/all_routes";
// import Table from "../../core/common/dataTable";
// import useApi from "../../core/customhook/useApi";
// import Loader from "../../core/common/selfLoder";

// const LIST_ENDPOINT = "/api/manager/team-resignationlist";
// const UPDATE_ENDPOINT = "/api/manager/update-resignation-status";

// const TeamResignationStatus = () => {
//     const [status, setStatus] = useState("PENDING");
//     const [refreshKey, setRefreshKey] = useState(0);

//     /* =======================
//        Fetch Resignation List
//        ======================= */
//     const {
//         data: resignationData,
//         loading: listLoading,
//     } = useApi(LIST_ENDPOINT, {
//         method: "POST",
//         autoCall: true,
//         payload: { status },
//         dependencies: [status, refreshKey],
//     });

//     /* =======================
//        Update Status API
//        ======================= */
//     const { callApi: callUpdateApi, loading: updateLoading } = useApi(
//         UPDATE_ENDPOINT,
//         {
//             method: "POST",
//             autoCall: false,
//         }
//     );

//     /* =======================
//        Approve Resignation
//        ======================= */
//     const approveResignation = async (employeeId: string) => {
//         const result = await Swal.fire({
//             title: "Approve Resignation?",
//             text: "Are you sure you want to approve this resignation?",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonText: "Approve",
//         });

//         if (result.isConfirmed) {
//             await callUpdateApi({
//                 employee_id: employeeId,
//                 status: "APPROVED",
//             });

//             Swal.fire("Approved!", "Resignation approved successfully.", "success");
//             setRefreshKey((prev) => prev + 1);
//         }
//     };

//     /* =======================
//        Reject Resignation
//        ======================= */
//     const rejectResignation = async (employeeId: string) => {
//         const result = await Swal.fire({
//             title: "Reject Resignation",
//             input: "textarea",
//             inputPlaceholder: "Enter rejection reason...",
//             showCancelButton: true,
//             confirmButtonText: "Reject",
//             inputValidator: (value) =>
//                 !value?.trim() ? "Reason is required!" : null,
//         });

//         if (result.isConfirmed) {
//             await callUpdateApi({
//                 employee_id: employeeId,
//                 status: "REJECTED",
//                 rejected_reason: result.value,
//             });

//             Swal.fire("Rejected!", "Resignation rejected.", "success");
//             setRefreshKey((prev) => prev + 1);
//         }
//     };

//     /* =======================
//        Table Columns
//        ======================= */
//     const columns = [
//         {
//             title: "Employee Code",
//             dataIndex: "employee_id",
//         },
//         {
//             title: "Employee Name",
//             dataIndex: "employee_name",
//             render: (text: string, record: any) => (
//                 <Link to={`/resignation/resignation-view/${record.employee_id}`}>
//                     {text}
//                 </Link>
//             ),
//         },
//         {
//             title: "Date of Joining",
//             dataIndex: "join_date",
//             render: (date: string) =>
//                 date ? dayjs(date).format("DD MMM YYYY") : "—",
//         },
//         {
//             title: "Resignation Date",
//             dataIndex: "resignation_date",
//             render: (date: string) =>
//                 date ? dayjs(date).format("DD MMM YYYY") : "—",
//         },
//         {
//             title: "Zone",
//             dataIndex: "zone",
//         },
//         {
//             title: "Branch",
//             dataIndex: "branch_name",
//         },
//         {
//             title: "Department",
//             dataIndex: "department",
//         },
//         {
//             title: "Status",
//             dataIndex: "status",
//             render: (text: string) => (
//                 <span
//                     className={`badge ${text === "APPROVED"
//                         ? "bg-success"
//                         : text === "REJECTED"
//                             ? "bg-danger"
//                             : "bg-warning"
//                         }`}
//                 >
//                     {text}
//                 </span>
//             ),
//         },
//         {
//             title: "Action",
//             render: (_: any, record: any) => (
//                 <div className="action-icon d-inline-flex">
//                     {record.status === "PENDING" ? (
//                         <>
//                             <Link
//                                 to="#"
//                                 className="text-success"
//                                 title="Approve"
//                                 onClick={() => approveResignation(record.employee_id)}
//                             >
//                                 <i className="ti ti-circle-check" />
//                             </Link>

//                             <Link
//                                 to="#"
//                                 className="text-danger"
//                                 title="Reject"
//                                 onClick={() => rejectResignation(record.employee_id)}
//                             >
//                                 <i className="ti ti-circle-x" />
//                             </Link>
//                         </>
//                     ) : (
//                         <i className="ti ti-eye text-info" />
//                     )}
//                 </div>
//             ),
//         },
//     ];

//     /* =======================
//        Status Buttons
//        ======================= */
//     const statuses = [
//         { label: "Pending", value: "PENDING" },
//         { label: "Approved", value: "APPROVED" },
//         { label: "Rejected", value: "REJECTED" },
//     ];

//     return (
//         <>
//             <Loader loading={listLoading || updateLoading} />

//             <div className="page-wrapper">
//                 <div className="content">
//                     <h2 className="mb-3">Offboarding Applications</h2>

//                     {/* Status Filter */}
//                     <div className="mb-3 d-flex gap-2">
//                         {statuses.map((s) => (
//                             <button
//                                 key={s.value}
//                                 className="btn"
//                                 style={{
//                                     backgroundColor:
//                                         status === s.value ? "#2e3294" : "transparent",
//                                     color: status === s.value ? "#fff" : "#2e3294",
//                                     border: "1px solid #2e3294",
//                                     borderRadius: "20px",
//                                 }}
//                                 onClick={() => setStatus(s.value)}
//                             >
//                                 {s.label}
//                             </button>
//                         ))}
//                     </div>

//                     {/* Table */}
//                     <div className="card">
//                         <div className="card-body">
//                             <Table
//                                 dataSource={resignationData?.data || []}
//                                 columns={columns}
//                                 Selection={false}
//                                 showSearchInput
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 <div className="footer text-center bg-white border-top p-3">
//                      © {new Date().getFullYear()} WeConnect. All rights reserved.
//                 </div>
//             </div>
//         </>
//     );
// };

// export default TeamResignationStatus;
